export default __webpack_public_path__ + "static/media/primadonna5.61909436.jpg";